export default __webpack_public_path__ + "static/media/ua-safety-icon.ece48c70.png";